import { ReactElement } from 'react'
import { South } from '@mui/icons-material'
import { Box } from '@mui/material'
import usePlanImageCardTool from '@editor/hooks/usePlanImageCardTool'
import usePlanTableTool from '@editor/hooks/usePlanTableTool'
import { ToggleButton } from '@ui/actions'
import {
  Toolbar as EditorToolbar,
  ToolbarGroup,
  WallSelect,
  EditElementSelect,
  StoreyControls,
  CommentToolSelect,
  BuildingToolSelect,
  useAddCommentTool,
  PlanTableToolSelect,
  PlanImageCardToolSelect,
} from '@editorComponents'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'

const Toolbar = (): ReactElement => {
  const {
    params: { mode, storey },
    modes: {
      isDrawMode,
      isDrawingVerticalRoofMode,
      isDrawingPurlinsMode,
      isDrawingBeamsMode,
      isWallRipMode,
      isDrawingSlabMode,
      isDrawingRoofMode,
      isLoadMode,
      isBuildingMode,
    },
    actions: { toggleMode, setStorey },
  } = useStructuralPlanningSelection()

  const { isActive: isAddCommentActive, toggle: toggleAddComment } = useAddCommentTool()
  const { isActive: isAddPlanTableActive, toggle: toggleAddPlanTable } = usePlanTableTool()
  const { isActive: isAddPlanImageCardActive, toggle: toggleAddPlanImageCard } =
    usePlanImageCardTool()

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      >
        <Box sx={{ pointerEvents: 'all', padding: 0 }}>
          <StoreyControls storey={storey ?? null} setStorey={setStorey} />
        </Box>
      </Box>

      <EditorToolbar
        sx={{
          pointerEvents: 'none',
        }}
      >
        <ToolbarGroup>
          <WallSelect
            onClick={() => toggleMode('selection')}
            value={mode === 'selection'}
            hint="Aussteifende Elemente auswählen"
            tooltipPlacement="top"
            data-cy="btn-stiffening-proposal"
          />

          <ToggleButton
            hint="Lasten aufprägen"
            tooltipPlacement="top"
            size="small"
            onClick={() => toggleMode('point-load')}
            selected={isLoadMode}
            Icon={South}
            data-cy="btn-toggle-loads"
          />

          <BuildingToolSelect
            isBuildingActive={isBuildingMode}
            onToggleBuilding={() => {
              toggleMode('building')
            }}
          />

          <EditElementSelect
            onClick={value => {
              toggleMode(value)
            }}
            value={
              isDrawMode ||
              isDrawingVerticalRoofMode ||
              isDrawingPurlinsMode ||
              isDrawingBeamsMode ||
              isWallRipMode ||
              isDrawingSlabMode ||
              isDrawingRoofMode
                ? (mode as StructuralPlanningModes)
                : undefined
            }
          />
        </ToolbarGroup>

        <ToolbarGroup>
          <CommentToolSelect
            isAddCommentActive={isAddCommentActive}
            onToggleAddComment={toggleAddComment}
          />

          <PlanTableToolSelect
            isAddPlanTableActive={isAddPlanTableActive}
            onToggleAddPlanTable={toggleAddPlanTable}
          />

          <PlanImageCardToolSelect
            isAddPlanImageCardActive={isAddPlanImageCardActive}
            onToggleAddPlanImageCard={toggleAddPlanImageCard}
          />
        </ToolbarGroup>
      </EditorToolbar>
    </>
  )
}

export default Toolbar
